/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react'
import { useRequest } from '../../hooks/UseRequest'
import Loading from '../../components/Loading'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectModules } from '../../redux/moduleSlice'
import DashletTooltip from '../../components/elements/DashletTooltip'
import NoRecord from '../../components/elements/NoRecord'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faX, faCheck } from '@fortawesome/free-solid-svg-icons'
import { selectDropdownOptions } from '../../redux/dropdownSlice'

function PortfolioDashlet({ endpointPath }) {
  const requests = useRequest()
  const requesting = useRef(false)
  const [row, setRow] = useState([])
  const [loaded, setLoaded] = useState(false)
  const [module, setModule] = useState()
  const modules = useSelector(selectModules)
  const dropdownOptions = useSelector(selectDropdownOptions)

  useEffect(() => {
    const getRow = async () => {
      requests.setEndpoint(endpointPath)
      try {
        const response = await requests.get()
        setRow(response.data.data)
        const m = modules.data.find((e) => e.code_key === 'portfolio')
        setModule(m)
        setLoaded(true)
      } catch (error) {
        setLoaded(true)
      }
    }
    if (!requesting.current && endpointPath && row.length === 0) {
      setLoaded(false)
      requesting.current = true
      getRow()
    }
  }, [endpointPath])

  const renderHeader = (column_name, customize_label = false) => {
    if (customize_label) {
      return column_name;
    }
    const data = module.module_fields.find(
      (header) => header.column_name === column_name
    )
    if (data && !data.helper_text) {
      return data?.label_name
    }
    return <DashletTooltip columnName={data?.label_name} tooltipText={data?.helper_text} />
  }

  return (
    <div className="message is-white lox-dashlet-detail">
      <div className="message-header has-background-primary has-text-white lox-dashlet-detail__title py-0">
        <p className="is-size-4">Portfolio: {row.name}</p>
      </div>
      <div className="message-body py-0 px-1">
        {loaded && row && row.id && (
          <>
            <div className="columns m-0">
              <div className={`column py-1 px-0`}>
                <span className="lox-dashlet-detail__item__label has-text-grey is-size-8 pl-2">
                  {renderHeader('id')}
                </span>
                <span className="lox-dashlet-detail__item__data has-text-link is-size-8 pl-2">
                  <Link
                    key={`loan-dashlet-view-${row.id}`}
                    to={`/portfolio/${row.id}`}
                    className="lox-has-text-decoration-none"
                  >
                    {row.id}
                  </Link>
                </span>
              </div>
              <div className={`column ml-1 py-1 px-0`}>
                <div className="lox-dashlet-detail__item py-0 px-1">
                  <span className="lox-dashlet-detail__item__label has-text-grey is-size-8 pl-2">
                    {renderHeader('code_key')}
                  </span>
                  <span className="lox-dashlet-detail__item__data has-text-dark is-size-8 pl-2">
                    {row.code_key || '-'}
                  </span>
                </div>
              </div>
            </div>

            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('phone_number')}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                {row.phone_number || '-'}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('address')}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                {row.address || '-'}, {row.city || '-'}, {dropdownOptions[row.state_dropdown_option_id]?.name || '-'}, {row.zip_code_label || '-'}
              </p>
            </div>
            <div className="divider m-1 mx-1"></div>

            <div className="columns m-0 ">
              <div className={`column py-1 px-0 ${row.is_instant_approval ? 'has-background-success' : 'has-background-danger has-text-info-light'} `}>
                <span className="px-3">
                  {row.is_instant_approval ? <FontAwesomeIcon icon={faCheck} className="has-text-white fa-sm" /> : <FontAwesomeIcon icon={faX} className="has-text-white" />}
                </span>
                <span className="lox-dashlet-detail__item__label is-size-8 ">
                  Auto Approval
                </span>
              </div>
              <div className={`column ml-1 py-1 px-0 ${row.is_automated_ach_origination ? 'has-background-success' : 'has-background-danger has-text-info-light'} `}>
                <div className="lox-dashlet-detail__item py-0 px-1">
                  <span className="px-3">
                    {row.is_automated_ach_origination ? <FontAwesomeIcon icon={faCheck} className="has-text-white fa-sm" /> : <FontAwesomeIcon icon={faX} className="has-text-white" />}
                  </span>
                  <span className="lox-dashlet-detail__item__label is-size-8">
                    Auto-ACH Orig
                  </span>
                </div>
              </div>
            </div>
            <div className="columns m-0">
              <div className={`column mt-1 py-1 mb-0 px-0 ${row.is_debit_card_funding ? 'has-background-success' : 'has-background-danger has-text-info-light'} `}>
                <span className="px-3">
                  {row.is_debit_card_funding ? <FontAwesomeIcon icon={faCheck} className="has-text-white fa-sm" /> : <FontAwesomeIcon icon={faX} className="has-text-white" />}
                </span>
                <span className="lox-dashlet-detail__item__label is-size-8">
                  Debit Card Funding
                </span>
              </div>
              <div className={`column ml-1 mt-1 mb-0 py-1 px-0 ${row.is_tango_active ? 'has-background-success' : 'has-background-danger has-text-info-light'} `}>
                <div className="lox-dashlet-detail__item py-0 px-1 ">
                  <span className="px-3">
                    {row.is_tango_active ? <FontAwesomeIcon icon={faCheck} className="has-text-white fa-sm" /> : <FontAwesomeIcon icon={faX} className="has-text-white" />}
                  </span>
                  <span className="lox-dashlet-detail__item__label is-size-8 has-text-centered">
                    Tango
                  </span>
                </div>
              </div>
            </div>

            <div className="columns m-0">
              <div className={`column mt-1 py-1 mb-1 px-0 ${row.has_real_time_payment ? 'has-background-success' : 'has-background-danger has-text-info-light'} `}>
                <span className="px-3">
                  {row.has_real_time_payment ? <FontAwesomeIcon icon={faCheck} className="has-text-white fa-sm" /> : <FontAwesomeIcon icon={faX} className="has-text-white" />}
                </span>
                <span className="lox-dashlet-detail__item__label is-size-8">
                  Real Time Funding
                </span>
              </div>
              <div className={`column ml-1 mt-1 mb-1 py-1 px-0 ${row.is_bank_verification_ssv ? 'has-background-success' : 'has-background-danger has-text-info-light'} `}>
                <div className="lox-dashlet-detail__item py-0 px-1">
                  <span className="px-3">
                    {row.is_bank_verification_ssv ? <FontAwesomeIcon icon={faCheck} className="has-text-white fa-sm" /> : <FontAwesomeIcon icon={faX} className="has-text-white" />}
                  </span>
                  <span className="lox-dashlet-detail__item__label is-size-8">
                    DL in SSV
                  </span>
                </div>
              </div>
            </div>
          </>
        )}
        {!loaded && <Loading />}
        {loaded && row.length === 0 && <NoRecord />}
      </div>
    </div>
  )
}

export default PortfolioDashlet
